
import state from './../../zviz2/zviz/state';
import {default as Group, Controller as GroupController} from './../../zviz2/zviz/components/group';
import Link from './../../zviz2/zviz/components/link';
import Scroller from './../../zviz2/zviz/components/scroll';
import {default as TextBox, Controller as TextBoxController} from './../../zviz2/zviz/components/textbox';
import {default as TextInput, Controller as TextInputController} from './../../zviz2/zviz/components/form/text';
import Rectangle from './../../zviz2/zviz/components/rectangle';
import ActiveFilter from './active';
import {extend, createObjectFromData} from './../../zviz2/zviz/functions';
import filterModel from './../../model/filter';
import {styleText, styleHeader2} from './../../styles';
import config from './../../config';

//import {LifeCycle} from './../zviz2/zviz/cycle';

class Controller extends GroupController{

    constructor(parent, blueprint={}){

        super(parent, blueprint);

        this.options = [];

        this.currentFilter = null;
        this.isLoading = false;

    }


    loadData(){
        // todo: add loader
        if(this.models['filter'].status != 'success'){
            return [];
        }
        this.options = [];
        let data = this.models['filter'].data[this.data.name] || [];
        for(var x = 0; x < data.length; x++){
            let obj = createObjectFromData(data[x], {v: ['v', '[unknown]'], a: ['a', 0]});
            if(obj.v == '__EMPTY__'){
                obj.v = 'Unspecified type';
            }
            this.options.push(obj);
            // if(x > 8){
            //     break;
            // }
        }

        this.update();
    }

    getChildren(){
        
        this.loadData();
        this.currentFilter = state.get('quickFilter.filter.' +  this.data.name);

        let result = [];

        let i = 0;
        for(let o of this.options){

            if(this.currentFilter){
                if(o.v.normalize('NFKD').toLowerCase().search(this.currentFilter.normalize('NFKD').toLowerCase()) == -1){
                    continue;
                }
            }

            result.push(extend({
                properties: { 
                    data: {
                        name: this.data.name,
                        value: o.v,
                        amount: o.a,
                        index: i
                    }
                }
            }, BlueprintItem));
            i++;
        }

        return result;
    }

}


class ItemController extends TextBoxController{

    constructor(parent, blueprint={}){

        super(parent, blueprint);

    }

    getFilter(){
        let name = this.data.name;
        let filter = state.get('filter.' + name);

        if(! filter){
            filter = [];
        }
        if(! (filter instanceof Array)){
            filter = [filter];
        }
        return filter;
    }

    getColor(){
        let color = '#230050';
        let filter = this.getFilter();
        if(filter.length > 0){
            if(filter.indexOf(this.data.value) == -1){
                color = '#b5b5b5';
            }
        }
        return color;
    }

    onItemClick(event){

        let filter = state.get('filter.' + this.data.name);

        if(! filter){
            filter = [];
        }
        if(! (filter instanceof Array)){
            filter = [filter];
        }
        for(let i = 0; i < filter.length; i++){
            if(filter[i] == this.data.value){
                filter.splice(i, 1);
                if(filter.length == 0){
                    filter = null;
                }
                state.set('filter.'+this.data.name, filter);
                return;
            }
        }
        filter.push(this.data.value);

        state.set('filter.'+this.data.name, filter);
    }

}

class MyTextInput extends TextInputController{

    constructor(parent, blueprint={}){
        super(parent, blueprint);
        // this.blueprint = createObjectFromDefault(blueprint, this.blueprint);
        this.restoreFocus = 0;
    }

    init(renderer){
        super.init(renderer);
        let val = state.get('quickFilter.filter.' + this.parent.parent.data.name) || ''; 
        this.renderOutput.result.setAttribute('value', val);
    }

}

let SearchBlueprint = extend({
    listeners: [
        (ctrl) => ( ctrl.addListener(state, [ctrl, ctrl.update], 'quickFilter.filter.' +  ctrl.data.name) )
    ],
    properties: {
        style: {
            position: 'relative'
        },
        data: {
            name: '',
            currentFilter: (ctrl) => ( state.get('quickFilter.filter.' + ctrl.data.name) )
        }
    },
    children: [
        extend({
            type: MyTextInput,
            properties: {
                style: extend({
                    border: '1px solid #151f85',
                    outline: 'none',
                    padding: '0',
                    textIndent: '7px',
                    fontStyle: 'italic',
                    fontSize: '10pt',
                    height: '20px',
                    lineHeight: '20px',
                    width: '99%'
                }, styleText),
                attributes: { 
                    'placeholder': 'Filter',
                    // value: (ctrl) => ( state.get('quickFilter.filter.' + ctrl.parent.parent.data.name) || '' )
                }
            },
            events: {
                keyup: (event, ctrl) => {
                    let node = event.currentTarget; 
                    let field = ctrl.parent.data.name;
                    // check if all browser already have the value of input updated at this time
                    state.set('quickFilter.filter.' + field, node.value);
                }
            }
        }, TextInput),

        extend({
            properties: {
                style: {
                    position: 'absolute',
                    display: 'block',
                    top: '0px',
                    right: '0px',
                    width: '20px',
                    height: '20px',
                    background: (ctrl) => ( (ctrl.parent.data.currentFilter == '')? 
                            'transparent':
                            'transparent url(\'' + config.imgPath + 'delete_filter_small.png\') center center no-repeat' )
                }
            },
            events: {
                click: (event, ctrl) => {
                    let field = ctrl.parent.data.name;
                    state.set('quickFilter.filter.' + field, null); 
                    ctrl.parent.renderOutput.result.children[0].value = '';
                }
            }
        }, Link)
    ]
}, Group);


let Blueprint = {
    type: Controller,
    models: {
        'filter': null
    },
    listeners: [
        (ctrl) => ( ctrl.addListener(ctrl.models['filter'], [ctrl, ctrl.update]) ),
        (ctrl) => ( ctrl.addListener(state, [ctrl, ctrl.update], 'quickFilter.filter.' +  ctrl.data.name) ),
    ],
    properties: {
        data: {
            name: 'eval_type',
            title: (ctrl) => (
                ctrl.data.name == 'country' ? 
                    'Region/Country':
                    (ctrl.data.name == 'funding_source' ?
                        'Funding source' :
                        config.data.dimensionTitles[ctrl.data.name])
            ),
            childrenCount: (ctrl) => (ctrl.options.length),
            hideTitle: false
        },
        style: { 
            overflow: 'hidden',
            marginBottom: '15px'
        }
    },
    children: [
        (ctrl) => ( ctrl.data.hideTitle? [] :
            extend({
                properties: {
                    style: extend({
                        fontSize: '11pt',
                        lineHeight: '1.5em',
                        width: '100%',
                        display: 'block',
                        marginTop: '5px'
                    }, styleHeader2),
                    content: (ctrl) => ( ctrl.parent.data.title )
                }
            }, TextBox)
        ),

        extend({
            properties:{
                data: {
                    filter: (ctrl) => (ctrl.parent.data.name),
                    includeSeparator: true
                }
            }
        }, ActiveFilter),

        (ctrl) => {
            return (ctrl.data.childrenCount > 15 || state.get('quickFilter.filter.'+ctrl.data.name))? 
                    extend({
                        properties: {
                            data: {
                                name: ctrl.data.name
                            } 
                        }
                    }, SearchBlueprint): 
                    []; 
        },

        (parent) => (extend({
            models: {
                'filter': null
            },
            listeners: [
                (ctrl) => ( ctrl.addListener(ctrl.models['filter'], [ctrl, ctrl.update]) ),
                (ctrl) => ( ctrl.addListener(state, [ctrl, ctrl.update], 'quickFilter.filter.' + ctrl.parent.data.name) )
            ],
            properties: {
                style: extend({ 
                    fontSize: '8pt',
                    marginTop: '5px',
                    maxHeight: '150px',
                    position: 'relative'
                }, styleText),
                data: {
                    field: parent.data.name,
                    name: parent.data.title,
                    scrollY: true
                }
            },
            events: {  },
            children: [ (ctrl) => ( ctrl.parent.getChildren() ) ]
        }, Scroller))
    ]
};


let BlueprintNoItems = extend({
    properties: {
        style: extend({
                fontStyle: 'italic'
            }, styleText),
        content: 'No items'
    }
}, TextBox);

let BlueprintItem = {
    type: ItemController,
    properties:{
        style: {
            cursor: 'pointer',
            display: 'inline'
        },
        data: {
            value: '',
            amount: 0,
            color: (ctrl) => ( ctrl.getColor() )
        }
    },
    events: {
        click: (event, ctrl) => { ctrl.onItemClick(event); }
    },
    children: [
        extend({
            properties: {
                content: ' '
            }
        }, TextBox),

        extend({
            properties: {
                style: extend({
                    fontStyle: 'italic',
                    display: 'inline',
                    fontSize: '9pt',
                    color: (ctrl) => ( ctrl.parent.getColor() )
                }, styleText),
                content: (ctrl) => ( ctrl.parent.data.value )
            }
        }, TextBox),

        extend({
            properties: {
                style: extend({
                    fontStyle: 'italic',
                    marginLeft: '4px',
                    marginRight: '10px',
                    display: 'inline',
                    fontSize: '9pt',
                    color: '#b5b5b5'
                }, styleText),
                content: (ctrl) => ( '('+ctrl.parent.data.amount+')' )
            }
        }, TextBox)
    ]
};

export default Blueprint;
export {Controller, Blueprint};

